import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "revico-community-talk-notice-mail-form" }
const _hoisted_2 = { class: "revico-community-talk-notice-mail-form-header" }
const _hoisted_3 = { class: "revico-community-talk-notice-mail-form-wrapper" }
const _hoisted_4 = { class: "revico-community-talk-notice-mail-form-description" }
const _hoisted_5 = { class: "revico-community-talk-notice-mail-form-notice" }
const _hoisted_6 = { class: "revico-community-talk-notice-mail-form-submit-button-wrapper" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "revico-community-talk-notice-mail-complete" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "revico-community-talk-notice-mail-complete-text" }, "メール通知がONになりました。", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock($setup["ApiPostLoadMaster"], { status: $setup.status }, {
    beforeRequest: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString($setup.wordSettings?.mailNotificationHeader), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString($setup.wordSettings?.mailNotificationDescription), 1 /* TEXT */),
          _createVNode($setup["CustomInput"], {
            modelValue: $setup.mailAddress,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ($setup.mailAddress = $event)),
            name: "mailAddress",
            type: "email",
            placeholder: $setup.wordSettings?.mailNotificationEmailPlaceholder,
            customClass: "revico-community-talk-notice-mail-form-input-mailaddress",
            "api-validation-error-view-model": $setup.apiValidationErrorViewModel,
            maxlength: 256
          }, null, 8 /* PROPS */, ["modelValue", "placeholder", "api-validation-error-view-model"]),
          _createElementVNode("p", _hoisted_5, _toDisplayString($setup.wordSettings?.mailNotificationAnnotationText), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "revico-community-talk-notice-mail-form-submit-button",
              onClick: $setup.post,
              disabled: $setup.isProcessing
            }, [
              _createTextVNode(_toDisplayString($setup.wordSettings?.mailNotificationSendButtonLabel), 1 /* TEXT */),
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-paper-plane" })
            ], 8 /* PROPS */, _hoisted_7)
          ])
        ])
      ])
    ]),
    afterApiSuccess: _withCtx(() => [
      _createElementVNode("section", _hoisted_8, [
        _createVNode($setup["PostComplete"], null, {
          contents: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["status"]))
}